import { gql } from "@apollo/client";

export const UPDATE_USER_PROFILE = gql`
    mutation updateUser($id: ID!, $name: String, $title: String, $role: String, $chatSettings: JSON) {
        updateUser(id: $id, name: $name, title: $title, role: $role, chatSettings: $chatSettings) {
            id
            name
            title
        }
    }
`;
